module.exports = __webpack_public_path__ + "static/Alex-7c619316a29906c691448ede0b15c55b.png";